import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { CacheProvider } from '@emotion/react';

import App from './App';
import { theme } from './theme';
import { ViewModeProvider } from './contexts/ViewModeContext';
import { createEmotionCache } from './createEmotionCache';
import './i18n';

// Create Emotion cache with CSP nonce
const emotionCache = createEmotionCache();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <CacheProvider value={emotionCache}>
      <ViewModeProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </ViewModeProvider>
    </CacheProvider>
  </React.StrictMode>
);
